import { HttpClient, HttpHeaders } from '@angular/common/http';
import { delay, tap, take } from 'rxjs/operators';
import { UtilService } from '../util/util.service';
import { EMAIL_URL, SMS_URL } from '../../../app.constants';
import { EnvioEmail } from '../interfaces/envioEmail.interface';
import { EnvioSMS } from '../interfaces/envioSMS.interface';

export class CrudService<T> {

  constructor(protected http: HttpClient, public API_URL) { }

  findAll() {
    return this.http.get<T[]>(this.API_URL)
      .pipe(
        delay(2000),
      );
  }


  find(id) {
    return this.http.get<T>(`${this.API_URL}/${id}`, UtilService.getOptionsHeaders()).pipe(take(1))
  }

  private create(record: T) {
    return this.http.post(`${this.API_URL}`, record, { observe: 'response' }).toPromise();
  }

  private update(record: T) {
    return this.http.put(`${this.API_URL}/editar`, record, { observe: 'response' }).toPromise();
  }

  save(record: T) {
    if (record['id']) {
      return this.update(record);
    }
    return this.create(record);
  }

  remove(id) {
    return this.http.delete(`${this.API_URL}/${id}`).pipe(take(1));
  }

  apiEmail(contato, token) {

    const objEmail = <EnvioEmail>{
      assuntoEmail: 'Recuperação de conta',
      emailDestinatario: contato,
      fromEmail: 'sedes@centrus.org.br',
      textoEmail: 'Código de acesso:' + '<B><i><p style="color:blue">' + token
    }

    return this.http.post(EMAIL_URL, objEmail, UtilService.getOptionsHeaders())
      .toPromise();
  }

  apiCell(contato, token) {

    const objSMS = <EnvioSMS>{ numeroTelefone: contato, mensagemTexto: 'Codigo de acesso: ' + token }

    return this.http.post(SMS_URL, objSMS, UtilService.getOptionsHeaders())
      .toPromise();
  }



}






// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/crud-service.ts